import {
  all,
  debounce,
  takeLatest,
  put,
  call,
  select,
} from 'redux-saga/effects';
import {
  SEND_EXCO_INFO_REQUEST,
  SEND_EXCO_INFO_BY_EMPLOYEE_REQUEST,
  sendExcoInfoSuccess,
  GET_EXCO_INFO_MODAL_DATA_REQUEST,
  GET_EMPLOYEE_EXCO_INFO_MODAL_DATA_REQUEST,
  getExcoInfoModalDataSuccess,
  sendExcoInfoError,
  GET_CHECK_PENDING_CHANGES_REQUEST,
  getCheckPendingChangesSuccess,
  getExcoInfoModalDataRequest,
  setPendingChangesLoading,
} from 'modules/SalaryModule/SalaryModal/actions';
import { getEmployeeRewards } from 'modules/SalaryModule/RewardsTable/actions';
import { selectLastGetEmployeeRewardParams } from 'modules/SalaryModule/RewardsTable/selectors';

import {
  fetchExcoInfoModalData,
  finalizeExcoData,
  fetchCheckPendingChanges,
  finalizeExcoDataByEmployee,
  fetchEmployeeExcoInfoModalData,
} from '../services';

function* sendExcoInfoWorker({
  payload: { onSuccess = () => {}, date, comment, companyId },
}) {
  yield put(setPendingChangesLoading(true));

  try {
    yield call(finalizeExcoData, {
      month: date.month() + 1,
      year: date.year(),
      comment,
      companyId,
    });
    yield put(sendExcoInfoSuccess());
    yield put(
      getExcoInfoModalDataRequest({
        companyId,
      })
    );

    const lastGetEmployeeRewardParams = yield select(
      selectLastGetEmployeeRewardParams
    );

    yield put(getEmployeeRewards(lastGetEmployeeRewardParams));

    yield call(onSuccess);
  } catch (error) {
    yield put(sendExcoInfoError());
    console.warn(error);
  }
}

function* sendExcoInfoByEmployeeWorker({
  payload: { onSuccess = () => {}, date, comment, companyId, employeeId },
}) {
  yield put(setPendingChangesLoading(true));

  try {
    yield call(finalizeExcoDataByEmployee, {
      month: date.month() + 1,
      year: date.year(),
      comment,
      companyId,
      employeeId,
    });
    yield put(sendExcoInfoSuccess());
    yield put(
      getExcoInfoModalDataRequest({
        companyId,
      })
    );

    const lastGetEmployeeRewardParams = yield select(
      selectLastGetEmployeeRewardParams
    );

    yield put(getEmployeeRewards(lastGetEmployeeRewardParams));

    yield call(onSuccess);
  } catch (error) {
    yield put(sendExcoInfoError());
    console.warn(error);
  }
}

function* getExcoInfoModalDataWorker({ payload: { companyId } }) {
  yield put(setPendingChangesLoading(true));

  try {
    const { data } = yield call(fetchExcoInfoModalData, {
      companyId,
    });
    yield put(getExcoInfoModalDataSuccess({ data: data.updates }));
  } catch (error) {
    console.warn(error);
  }

  yield put(setPendingChangesLoading(false));
}

function* getEmployeeExcoInfoModalDataWorker({
  payload: { companyId, employeeId },
}) {
  yield put(setPendingChangesLoading(true));

  try {
    const { data } = yield call(fetchEmployeeExcoInfoModalData, {
      companyId,
      employeeId,
    });
    yield put(getExcoInfoModalDataSuccess({ data: data.updates }));
  } catch (error) {
    console.warn(error);
  }

  yield put(setPendingChangesLoading(false));
}

function* getCheckPendingChangesWorker({
  payload: { companyId, year, month },
}) {
  try {
    const { data } = yield call(fetchCheckPendingChanges, {
      companyId,
      year,
      month,
    });

    yield put(getCheckPendingChangesSuccess(data.changesArePended));
  } catch (error) {
    console.warn(error);
  }
}

function* debounceGetCheckPendingChangesWorker() {
  yield debounce(
    600,
    GET_CHECK_PENDING_CHANGES_REQUEST,
    getCheckPendingChangesWorker
  );
}

export function* salaryModalMainSaga() {
  yield all([
    takeLatest(SEND_EXCO_INFO_REQUEST, sendExcoInfoWorker),
    takeLatest(
      SEND_EXCO_INFO_BY_EMPLOYEE_REQUEST,
      sendExcoInfoByEmployeeWorker
    ),
    takeLatest(GET_EXCO_INFO_MODAL_DATA_REQUEST, getExcoInfoModalDataWorker),
    takeLatest(
      GET_EMPLOYEE_EXCO_INFO_MODAL_DATA_REQUEST,
      getEmployeeExcoInfoModalDataWorker
    ),
    debounceGetCheckPendingChangesWorker(),
  ]);
}
